import { Input } from '@commenda/kakashi';
import { BaseInputTemplateProps, getInputProps } from '@rjsf/utils';

export const BaseInputTemplate = (props: BaseInputTemplateProps) => {
  const { schema, options, value, onChange } = props;
  const inputProps = getInputProps(schema, undefined, options);
  return (
    <div className="mt-2">
      <Input
        {...inputProps}
        value={value ?? ''}
        onChange={(e) => onChange?.(e.target.value)}
      />
    </div>
  );
};
